import RootState from 'typings/RootState'
import { ChecklistTypeConfigList } from './types'
import { Event } from '../../types/event'

export const selectDataList = (state: RootState): ChecklistTypeConfigList =>
  state.adminChecklistTypeConfig.DataList

export const selectCountTypeList = (state: RootState) =>
  state.adminChecklistTypeConfig.CountTypeList

export const selectEvent = (state: RootState): Event =>
  state.adminChecklistTypeConfig.event

export const selectSorting = (state: RootState) =>
  state.adminChecklistTypeConfig.sorting
